import { FC } from 'react'

import { Box, Text } from '@factorialco/deprecated-design-system'
import {
  ProjectionKind,
  usePredefinedTemplatesDataTable,
} from 'generated/resources/datatable.graphql'

import DataTable from 'modules/core/components/DataTable'
import { useDebouncedSearch } from 'modules/core/hooks/useSearch'
import i18n from 'modules/core/lib/i18n'

import { ReviewTypeTag } from 'modules/performance_process/components/templates/ReviewTypeTag'
import { Actions } from './Actions'

type Props = {
  canCreateTemplates?: boolean
}

export const PredefinedTemplatesDataTable: FC<Props> = ({ canCreateTemplates }) => {
  const { search, debouncedSearch, onSearch } = useDebouncedSearch()
  const source = usePredefinedTemplatesDataTable(
    [
      {
        identifier: 'name',
        title: 'Name',
        fixed: true,
        template: '{{ name }}',
        kind: ProjectionKind.Custom,
        colSpan: 2,
        render: ({ name }) => {
          return <Text.Normal>{name}</Text.Normal>
        },
        sortBy: 'name',
      },
      {
        identifier: 'reviewerStrategies',
        title: i18n.t('performance_process.reviews.launch_review_types'),
        fixed: true,
        template: '{{ reviewerStrategies }}',
        kind: ProjectionKind.Custom,
        colSpan: 2,
        render: ({ id, reviewerStrategies }) => {
          return (
            <Box flexDirection="row" flexWrap="wrap" gap="s8">
              {reviewerStrategies?.map((type) => (
                <ReviewTypeTag type={type} key={`${id}-${type}`} />
              ))}
            </Box>
          )
        },
      },
      {
        identifier: 'actions',
        kind: ProjectionKind.Decorative,
        width: 100,
        fixed: true,
        render: (template) => {
          return <Actions template={template} canDuplicate={canCreateTemplates ?? false} />
        },
      },
    ],
    { variables: { ids: [], search: debouncedSearch } }
  )

  return (
    <DataTable.Provider
      source={source}
      sort={{
        path: 'name',
        direction: 'asc',
      }}
      filters={[]}
    >
      <Box gap="s16">
        <DataTable.HeadBar
          disableExport
          disableEditColumns
          search={{
            placeholder: i18n.t('common.search_by'),
            value: search,
            onChange: onSearch,
          }}
        />
        <DataTable.Table />
      </Box>
    </DataTable.Provider>
  )
}
